
// DashboardLayout pages
import Overview from './Overview.vue'
import People from './People.vue'
import Person from './Person.vue'
import NewPerson from './NewPerson.vue'
import UserProfile from './UserProfile.vue'
import Admins from './Admins.vue'
import Plays from './Plays.vue'
import Play from './Play.vue'
import NewPlay from './NewPlay.vue'
import Theaters from './Theaters.vue'
import Theater from './Theater.vue'
import NewTheater from './NewTheater.vue'
import Companies from './Companies.vue'
import Company from './Company.vue'
import NewCompany from './NewCompany.vue'
import Setting from './Setting.vue'
import Lists from './Lists.vue'
import List from './List.vue'
import Pages from './Pages.vue'
import PageEdit from "./PageEdit.vue"
import Sponsors from "./Sponsors.vue"

export default {
  Overview,
  People,
  Person,
  NewPerson,
  UserProfile,
  Admins,
  Plays,
  Play,
  NewPlay,
  Theaters,
  Theater,
  NewTheater,
  Companies,
  Company,
  NewCompany,
  Setting,
  Lists,
  List,
  Pages,
  PageEdit,
  Sponsors
};
